import StandardGateway from './lib/standard_gateway';

export default class AgentSkillsGateway extends StandardGateway {
  constructor(backend) {
    super(backend, 'v1/orgs/:orgId/agent-skills');
  }

  // fetchAll can take a comma-separated list of agent IDs in the agentIds key:
  // single agent: fetchAll({ agentIds: 'exampleAgentId' })
  // multiple agents: fetchAll({ agentIds: 'exampleAgentId,anotherAgentId,thirdAgentId' })
  fetchAll(params, query) {
    const agentIdsQuery = params?.agentIds ? { 'f.aids': params.agentIds } : {};
    const queryParams = { ...query, ...agentIdsQuery };
    return super.fetchAll(params, queryParams);
  }
}
